import * as d3 from 'd3';

/**
 * Draw Tall Fractional Grilles — two vertical bars that extend ~60% of the window height from the top.
 */
export function drawTallFractionalGrillsOculus(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  fillColor = 'white',
  strokeColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  fractionalHeightRatio = 0.6, // how tall the bars are, relative to window height
  radiusX = width / 2,
  radiusY = height / 2,
  outerShape = 'Rect'
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const barHeight = glassHeight * fractionalHeightRatio;

  // Positions for the two vertical bars: 1/4 and 3/4 of the window width
  const leftBarX = glassX + glassWidth * 0.25;
  const rightBarX = glassX + glassWidth * 0.75;

  // ALWAYS clip grills to the inner glass ellipse (oculus is always a circle/oval)
  const clipId = `ellipseClip_${Math.random().toString(36).substring(2, 11)}`;
  const centerX = glassX + glassWidth / 2;
  const centerY = glassY + glassHeight / 2;

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('ellipse')
    .attr('cx', centerX)
    .attr('cy', centerY)
    .attr('rx', radiusX)
    .attr('ry', radiusY);

  const grillContainer = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  [leftBarX, rightBarX].forEach((barX) => {
    grillContainer.append('rect')
      .attr('x', barX - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', barHeight)
      .attr('fill', fillColor)
      .attr('stroke', strokeColor)
      .attr('stroke-width', borderWidth);
  });
}
